import script from "./ObservationRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ObservationRow.vue?vue&type=script&setup=true&lang=js"

import "./ObservationRow.vue?vue&type=style&index=0&id=6047396a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6047396a"]])

export default __exports__